import { mutatorAction } from 'satcheljs';
import getOrCreateSxSStoreData, { getStore } from '../store/Store';
import { SXSID_MAIN_WINDOW } from '../store/schema/SxSStore';

const moveSxSStoreMutator: (sxsId: string | null, newSxSId: string) => void = mutatorAction(
    'setType',
    (sxsId: string | null, newSxSId: string): void => {
        const sxsStore = getOrCreateSxSStoreData(sxsId);
        getStore().sxsStoreMapping.delete(sxsId || SXSID_MAIN_WINDOW);
        getStore().sxsStoreMapping.set(newSxSId, sxsStore);
    }
);

export default moveSxSStoreMutator;
